<template>
	<div :class="{TemplateInput:1,'fake-focus':!disabled&&focused,disabled}" >
		<div class="TemplateInputCode" >
			<CodeEditor
				ref="BodyEditor"
				v-on:command="handleCommand"
				v-model="body"
				:disabled="disabled"
				:variables="variables"
				:onFocus="function(){focused=true;}"
				:onBlur="function(){focused=false;}"
				:editable_variables="editable_variables"
				/>
		</div>
		<div v-if="editable_variables" class="TemplateInputVariables" >
			<VariableEditor
				ref="VariableEditor"
				v-on:command="handleCommand"
				v-model="variables"
				/>
		</div>
	</div>
</template>

<script>

	import TemplateName from "../components/TemplateName.vue";
	import VariableEditor from "../components/VariableEditor.vue";
	import CodeEditor from "../components/CodeEditor.vue";

	export default {

		components : {
			TemplateName,
			VariableEditor,
			CodeEditor,
		},

		props : [
			'disabled',
			'value',
			'editable_variables',
			],

		data(){
			return {
				focused : false,
				name : '',
				body : '',
				variables : [],
			}
		},

		watch: {
			value : function(){
				this.refreshFromVal();
			},
			body : function(){
				this.$emit('input', this.templateVal() )
			},
			variables : function(){
				this.$emit('input', this.templateVal() )
			},
		},


		beforeMount(){
			this.refreshFromVal();
		},

		methods:{
			refreshFromVal(){
				this.body = (this.value||{}).body || '';
				this.variables = (this.value||{}).variables || [];
			},
			handleCommand(x){
				this.$refs.BodyEditor.command(x);
				if(this.editable_variables){
					this.$refs.VariableEditor.command(x);
				}
			},
			templateVal(){
				return Object.assign({},this.value,{
									body : this.body,
									variables : this.variables,
								})
			},
		}
	}

</script>